import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './point-details.reducer';

export const PointDetailsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pointDetailsEntity = useAppSelector(state => state.pointDetails.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pointDetailsDetailsHeading">
          <Translate contentKey="fivePlusApp.pointDetails.detail.title">PointDetails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{pointDetailsEntity.id}</dd>
          <dt>
            <span id="pointType">
              <Translate contentKey="fivePlusApp.pointDetails.pointType">Point Type</Translate>
            </span>
          </dt>
          <dd>{pointDetailsEntity.pointType}</dd>
          <dt>
            <span id="point">
              <Translate contentKey="fivePlusApp.pointDetails.point">Point</Translate>
            </span>
          </dt>
          <dd>{pointDetailsEntity.point}</dd>
        </dl>
        <Button tag={Link} to="/point-details" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/point-details/${pointDetailsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PointDetailsDetail;
